import React from 'react';

import { Group, useMantineTheme } from '@mantine/core';
import { IconCopy, IconEye, IconTrashX } from '@tabler/icons-react';
import Menu from 'components/Menu';
import { WorkoutList } from 'types';

interface ActionsCellProps {
  workout: WorkoutList;
  permission: boolean;
  onPreview: (workout: WorkoutList) => void;
  onSaveAsTemplate: (workout: WorkoutList) => void;
  onDelete: (workout: WorkoutList) => void;
}

const ActionsCell = ({
  workout,
  permission,
  onPreview,
  onSaveAsTemplate,
  onDelete,
}: ActionsCellProps): JSX.Element => {
  const theme = useMantineTheme();
  const iconSize = theme.fontSizes.sm;

  return (
    <Group position='right' px='xs'>
      <Menu
        position='bottom-end'
        disabled={!permission}
        items={[
          { title: 'Preview', onClick: () => onPreview(workout), icon: <IconEye size={iconSize} /> },
          {
            title: 'Save as Template',
            onClick: () => onSaveAsTemplate(workout),
            icon: <IconCopy size={iconSize} />,
          },
          {
            title: 'Delete',
            onClick: () => onDelete(workout),
            icon: <IconTrashX size={iconSize} />,
            color: 'red',
            disabled: workout.hasResults,
          },
        ]}
      />
    </Group>
  );
};

export default ActionsCell;
